import React from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/Footer.scss";

// import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
// import Col from 'react-bootstrap/Col';

// Icons of Instagram, FB, Threads and TG
import { BsInstagram, BsFacebook, BsThreads, BsTelegram } from "react-icons/bs";

function Footer(): React.JSX.Element {
  return (
    <div id="footer">
      <Container>
        <Container
          id="socialMediaIcons"
          className="d-flex justify-content-center"
        >
          <div className="iconSet">
            <div className="iconSetItem">
              <a
                href="https://www.facebook.com/people/%E5%B0%88%E6%A5%AD%E6%B0%A3%E8%B1%A1-Professional-Meteorology/100063902499667/"
                className="icon"
              >
                <h1>
                  <BsFacebook size={35} />
                </h1>
              </a>
            </div>
            <div className="iconSetItem">
              <a
                href="https://www.instagram.com/professional_meteorology_hksar/"
                className="icon"
              >
                <h1>
                  <BsInstagram size={35} />
                </h1>
              </a>
            </div>
            <div className="iconSetItem">
              <a
                href="https://www.threads.net/@professional_meteorology_hksar/"
                className="icon"
              >
                <h1>
                  <BsThreads size={35} />
                </h1>
              </a>
            </div>
            <div className="iconSetItem">
              <a href="https://t.me/pmhkchannel" className="icon">
                <h1>
                  <BsTelegram size={35} />
                </h1>
              </a>
            </div>
          </div>
        </Container>

        <Container>
          <Row>Copyright © 2013-2025 專業氣象。保留一切權利。</Row>
          <Row>
            實時氣象資料由香港特別行政區政府資料一線通網站界面提供，有關資料原屬香港特別行政區政府和資料一線通網站所有。專業氣象並非該等資料的知識產權擁有人。
          </Row>
          <Row>頁面最後更新：2025年11月24日</Row>
          <Row>版本: v1.05</Row>
        </Container>
      </Container>
    </div>
  );
}

export default Footer;
